import React, {memo} from 'react'
import settings from '../conf';

const Shortcuts = memo(() => {
  
  return (
      <section>
        { settings.SHORTCUTS.map((item, i) => (
          <a href={item[1]} 
             className="sidebar__subitem" 
             key={i}>
             {item[0]} 
          </a>
        ))}
      </section>
  )

})

export default Shortcuts
